/**
 * Asynchronously import script
 *
 * @param {string} src - script tag src attribute to load asynchronously
 * @param {?Object} options - additional DOM attributes to script tag
 * @returns {boolean} - true means success of append
 */
function importScript(src, options = {}) {
  if (document.querySelector(`script[src="${src}"]`)) return false;

  const script = document.createElement('script');
  Object.keys(options).forEach((key) => {
    script[key] = options[key];
  });

  script.async = true;
  script.src = src;
  script.type = 'text/javascript';

  document.body.appendChild(script);
  return true;
}

export default importScript;
